import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ProjectsProvider } from "@/lib/projects";
import { FullScreenLoader } from "@/components/RouteGuards";
import { NavSidebar } from "./NavSidebar";

/**
 * Top-level authenticated layout: fixed-height flex with the nav sidebar on the
 * left and the routed view filling the rest. The router mounts this around the
 * app's protected routes and renders pages through the <Outlet/>. Wraps the
 * tree in ProjectsProvider so the sidebar and the Inbox share project selection.
 */
export function AppShell() {
  return (
    <ProjectsProvider>
      <div className="flex h-full w-full bg-canvas">
        <NavSidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden">
          {/* Page chunks are lazy-loaded; the sidebar stays put during transitions. */}
          <Suspense fallback={<FullScreenLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </ProjectsProvider>
  );
}
